import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";


//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";

class ExternalViewLedgerReport extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.products1 = [
      {
        id: "01",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "02",
        categories: "LPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "03",
        categories: "REAL",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "04",
        categories: "JIRAM",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
    ];

    this.products2 = [
      {
        id: "01",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "02",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "03",
        categories: "LPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "04",
        categories: "REAL",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
    ];
  }

  render() {
    this.columns1 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "weight",
        text: `${this.props.t('Weight / Carat')}`,
        footer: "7.50 CT",
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        footer: "05",
      },
      {
        dataField: "rate",
        text: `${this.props.t('Rate')}`,
        footer: "",
      },
      {
        dataField: "amount",
        text: `${this.props.t('Amount')}`,
        footer: "750",
      },
    ];

    this.columns2 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "weight",
        text: `${this.props.t('Weight / Carat')}`,
        footer: "7.50 CT",
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        footer: "05",
      },
      {
        dataField: "rate",
        text: `${this.props.t('Rate')}`,
        footer: "",
      },
      {
        dataField: "amount",
        text: `${this.props.t('Amount')}`,
        footer: "750",
      },
    ];
    const {history} = this.props;
    document.title = "admin-report-external";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("REPORTS")} />
            <Card>
              <form>
                <div className="pt-3">
                  <div className="row">
                    <div className="d-md-flex d-block justify-content-between px-4">
                      <div>
                        <h4 className="text-black fw-bold mb-4">
                          {this.props.t("View Ledger report")}
                        </h4>
                      </div>
                      {/* <div>
                        <label
                          htmlFor="date"
                          className="fs-4 pe-2 text-black fw-bold"
                        >
                          Date:
                        </label>
                        <input type="date" className="fs-4 border-0" />
                      </div> */}
                    </div>
                    <div className="col-xl-8 col-12">
                      <CardBody>
                        <Row>
                          <div className="mb-3 row">
                            <label
                              htmlFor="ledgerID"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t("Ledger Id")}
                              </h5>
                            </label>
                            <div className="col-md-10">
                              <input
                                disabled
                                className="form-control fs-5"
                                type="text"
                                name="ledgerID"
                                placeholder="JANGAD0000123"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label
                              htmlFor="partyName"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t('Party Name')}
                              </h5>
                            </label>
                            <div className="col-md-10">
                              <input
                                disabled
                                className="form-control fs-5"
                                type="text"
                                name="partyName"
                                placeholder="XYZ Diamond"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label
                              htmlFor="weight"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t("Total Weight")}
                              </h5>
                            </label>
                            <div className="col-md-10">
                              <input
                                className="form-control fs-5"
                                disabled
                                type="text"
                                name="weight"
                                placeholder="20.25 CT"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label
                              htmlFor="totalPcs"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t('Total No of Pieces')}
                              </h5>
                            </label>
                            <div className="col-md-10">
                              <input
                                disabled
                                className="form-control fs-5"
                                type="text"
                                name="totalPcs"
                                placeholder="30"
                              />
                            </div>
                          </div>
                        </Row>
                      </CardBody>
                    </div>
                    <div className="col-xl-4 col-12 pt-3">
                      <div className="px-4">
                        <div className="row border-gray py-3">
                          <div className="col-md-5 col-12 pt-2">
                            <h5>{this.props.t("Contact Person")} :</h5>
                          </div>
                          <div className="col-md-7 col-12 pt-2">
                            <h5>Brooklyn Simmons</h5>
                          </div>
                          <div className="col-md-5 col-12 pt-2">
                            <h5>{this.props.t("Mobile no.1")} : </h5>
                          </div>
                          <div className="col-md-7 col-12 pt-2">
                            <h5>+91 (132)(564)(9872)</h5>
                          </div>
                          <div className="col-md-5 col-12 pt-2">
                            <h5>{this.props.t("Mobile no.2")} : </h5>
                          </div>
                          <div className="col-md-7 col-12 pt-2">
                            <h5>+91 (132)(564)(9872)</h5>
                          </div>
                          <div className="col-md-5 col-12 pt-2">
                            <h5>{this.props.t("Email Address")} : </h5>
                          </div>
                          <div className="col-md-7 col-12 pt-2">
                            <h5>xyzdiamond12@gmail.com</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row px-3 pt-3">
                    <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                      <div>
                        <h4 className="fw-bold pb-3 text-black">
                          1.{this.props.t("Jangad Id")} - STOCK0000123 [ABC Diamond Unit
                          (Internal)]
                        </h4>
                      </div>
                      <div>
                        <div className="pt-3 pt-xxl-0">
                          <h4 className="d-inline text-black fw-bold pe-3">
                            {this.props.t('From Date')}: 01/01/2022 
                          </h4>
                          <h4 className="d-inline text-black fw-bold">
                            {this.props.t('To Date')}: 25/01/2022
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <BootstrapTable
                        keyField="id"
                        classes="foo"
                        headerClasses="background-light fs-5"
                        footerClasses="background-light fs-5"
                        bootstrap4={true}
                        data={this.products1}
                        columns={this.columns1}
                      />
                    </div>
                  </div>
                  <div className="row px-3 pt-4">
                    <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                      <div>
                        <h4 className="fw-bold pb-3 text-black">
                          2.{this.props.t("Jangad Id")} - STOCK0000124 [ABC Diamond Unit
                          (Internal)]
                        </h4>
                      </div>
                      <div>
                        <div className="pt-3 pt-xxl-0">
                          <h4 className="d-inline text-black fw-bold pe-3">
                            {this.props.t('From Date')}: 02/01/2022
                          </h4>
                          <h4 className="d-inline text-black fw-bold">
                            {this.props.t('To Date')}: 25/01/2022
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <BootstrapTable
                        classes="foo"
                        keyField="id"
                        headerClasses="background-light fs-5"
                        footerClasses="background-light fs-5"
                        bootstrap4={true}
                        data={this.products2}
                        columns={this.columns2}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row px-3 pt-3">
                    <label htmlFor="notes" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t("Ledger Notes")}</h5>
                    </label>
                    <div className="col-md-10">
                      <textarea
                        disabled
                        className="form-control fs-5"
                        type="text"
                        name="notes"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>

                  <div className="col-md-12 text-center text-md-end pe-3 py-5">
                    <div className="btn-group">
                      <Button
                        color="primary"
                        className="fs-4 px-5"
                        type="submit"
                        onClick={() => this.props.history.push("/external-ledger-report")}
                      >
                       Back
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default ExternalViewLedgerReport;
